var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
import { YURL } from 'yurl';
const apiBaseUrl = new YURL(process.env.NEXT_PUBLIC_API_BASE_URL || '').pathname('api/settings');
export const getSettingValue = (props, trackException) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    try {
        const options = {
            timeout: 10000,
            data: '',
            url: apiBaseUrl
                .clone()
                .pathname(`/api/settings/value`)
                .query({ key: (_a = props.key) !== null && _a !== void 0 ? _a : '', languageCode: (_b = props.languageCode) !== null && _b !== void 0 ? _b : '' })
                .format(),
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        };
        const response = yield axios(options);
        const { status, data } = response;
        if (data == null || status < 200 || status >= 300) {
            trackException(new Error('Failed to get setting value'));
            return null;
        }
        return data;
    }
    catch (e) {
        trackException(new Error(`Failed to get setting value. ${e}`));
        return null;
    }
});
export const getSetting = (props, trackException) => __awaiter(void 0, void 0, void 0, function* () {
    var _c, _d;
    try {
        const options = {
            timeout: 10000,
            data: '',
            url: apiBaseUrl
                .clone()
                .query({ key: (_c = props.key) !== null && _c !== void 0 ? _c : '', languageCode: (_d = props.languageCode) !== null && _d !== void 0 ? _d : '' })
                .format(),
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        };
        const response = yield axios(options);
        const { status, data } = response;
        if (data == null || status < 200 || status >= 300) {
            trackException(new Error('Failed to get setting'));
            return null;
        }
        return data;
    }
    catch (e) {
        trackException(new Error(`Failed to get setting. ${e}`));
        return null;
    }
});
export const updateSettingValue = (props, trackException) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const options = {
            timeout: 10000,
            data: props,
            url: apiBaseUrl.clone().format(),
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        };
        const response = yield axios(options);
        const { status } = response;
        if (status < 200 || status >= 300) {
            trackException(new Error('Failed to update setting value'));
        }
    }
    catch (e) {
        trackException(new Error(`Failed to update setting value. ${e}`));
    }
});
export const createSettingValue = (props, trackException) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const options = {
            timeout: 10000,
            data: props,
            url: apiBaseUrl.clone().format(),
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        };
        const response = yield axios(options);
        const { status } = response;
        if (status < 200 || status >= 300) {
            trackException(new Error('Failed to create setting value'));
        }
    }
    catch (e) {
        trackException(new Error(`Failed to create setting value. ${e}`));
    }
});
